import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Texture } from '../../../odie';
import { FossilBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/fossil'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class FossilBlockView extends Container {
  private movieclip: MovieClip;
  private _count = 0;

  constructor(props: FossilBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.playAnimation('fossil_state01');

    this.y += 1;
  }

  public static assets() {
    return Object.values(manifest());
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    this._count = value;
    this.updateView();
  }

  private updateView() {
    switch (this._count) {
      case 3:
        this.playAnimation('fossil_state01');
        break;
      case 2:
        this.playAnimation('fossil_tranisition_1_2', 'fossil_state02');
        break;
      case 1:
        this.playAnimation('fossil_transition_2_3', 'fossil_state03');
        break;
      case 0:
        this.playAnimation('fossil_transition_3_4', 'fossil_state04');
        break;
    }
  }

  private async playAnimation(...anims: string[]) {
    // Play all animations but the last, in sequence
    const allAnimsButLast = anims.slice(0, -1);
    for (const anim of allAnimsButLast) {
      await this.movieclip.playAsync(anim);
    }
    // Last anim is looped
    const lastAnim = anims[anims.length - 1];
    this.movieclip.play(lastAnim, null, true);
  }
}
